module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.7fb0e378.woff2";